import React from 'react'
import PropTypes from 'prop-types'

const OfferSearchDateTime = ({ dateString, timeString, dateTimeSeparatedLine, className }) => {
  switch (true) {
    case !!dateString && !!timeString:
      if (dateTimeSeparatedLine) {
        return (
          <>
            <p className={className}>{dateString}</p>
            <p className={className}>{timeString}</p>
          </>
        )
      } else {
        return (
          <p className={className}>
            {dateString} <span>{timeString}</span>
          </p>
        )
      }
    case !!dateString:
      return <p className={className}>{dateString}</p>

    case !!timeString:
      return <p className={className}>{timeString.replace('von ', '')}</p>

    default:
      return null
  }
}

OfferSearchDateTime.propTypes = {
  dateString: PropTypes.string,
  timeString: PropTypes.string,
  dateTimeSeparatedLine: PropTypes.bool,
  className: PropTypes.string,
}

OfferSearchDateTime.defaultProps = {
  dateTimeSeparatedLine: false,
  className: '',
}

export default OfferSearchDateTime
